import { render, staticRenderFns } from "./DialogCard.vue?vue&type=template&id=353898f8&"
import script from "./DialogCard.vue?vue&type=script&lang=ts&"
export * from "./DialogCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports